/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


    var fixTabCollectionsMobile = function() {
    if (window.innerWidth > 767) return;
    
    var sliders = document.querySelectorAll('.tabs-collections .grid--mobile-slider');
    sliders.forEach(function(slider) {
      var flkty = window.Flickity && window.Flickity.data(slider);
      if (flkty) flkty.destroy();
      
      slider.style.display = 'grid';
      slider.style.gridTemplateColumns = 'repeat(2, 1fr)';
      slider.style.gap = '8px';
    });
  };

  setTimeout(fixTabCollectionsMobile, 500);
  setTimeout(fixTabCollectionsMobile, 1500);
  setTimeout(fixTabCollectionsMobile, 3000);
  
  document.addEventListener('DOMContentLoaded', fixTabCollectionsMobile);
  window.addEventListener('resize', fixTabCollectionsMobile);





  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
